// extracted by mini-css-extract-plugin
export default {"historyTable":"style_historyTable__wu83k"};